/*
 * @Author: ezhizao 庄德政
 * @LastEditors: ezhizao 庄德政
 * @Description: 
 */
const checkActive = {
  lastTime: new Date().getTime(),
  currentTime: new Date().getTime(),
  // 检测的间隔时间，默认是30秒
  intervalTime: 30 * 1000,
  // 设置超时时间： 30分
  timeOut: 30 * 60 * 1000,
  timer: null,
  vue: null,
  // 检测用户活跃情况
  check: function (_vue) {
    const _this = this
    _this.vue = _vue
    _this.lastTime = new Date().getTime()
    window.onload = function () {
      /* 检测鼠标移动事件 */
      document.addEventListener('mousemove', function () {
        // 更新最后的操作时间
        _this.lastTime = new Date().getTime()
      })
      document.addEventListener('keydown', function () {
        // 更新最后的操作时间
        _this.lastTime = new Date().getTime()
      })
    }

    /* 定时器  间隔1分钟，检测是否长时间未操作页面  */
    this.timer = window.setTimeout(function () {
      _this.compared(_this)
    }, _this.intervalTime)
  },
  // 超时函数，比较当前时间与上一次移动鼠标时间
  compared: function (_this) {
    // 更新当前时间
    _this.currentTime = new Date().getTime()
    const b = _this.currentTime - _this.lastTime > _this.timeOut
    // 判断是否超时
    if (b) {
      // 清除掉定时器
      window.clearTimeout(_this.timer)
      sessionStorage.setItem('authorization', 'null')
      _this.vue.logout()
    } else {
      this.timer = window.setTimeout(function () {
        _this.compared(_this)
      }, _this.intervalTime)
    }
  }
}

export default checkActive
